import client from '@/services/network/http'
import { TxConditionModel, TxRecordsModel } from '@/services/apis/history/model'
import { PageModel } from '@/services/apis/BaseModel'
class TxRecordApi {
  get<T>(url: string) {
    return client.get<T>(`/transaction${url}`)
  }
  post<T>(url: string, data?: object | string | number) {
    return client.post<T>(`/transaction${url}`, { bizContent: data })
  }
  getCondition() {
    return this.get<TxConditionModel>('/web/tx/selectCondition')
  }
  searchTxRecords({ pageNumber = 1, pageSize = 50, queryParam = {} }) {
    return this.post<PageModel<TxRecordsModel>>('/web/tx/queryTxByPage', {
      pageNumber,
      pageSize,
      queryParam,
    })
  }
  exportRecord(params: any) {
    return this.post('/download/txRecordDownload', params)
  }
  getExportList({ pageNumber = 1, pageSize = 10 }) {
    return this.post('/download/queryDownloadRecord', {
      pageNumber,
      pageSize,
    })
  }
  getExportUrl(id: string) {
    return this.post('/download/queryUrl', id)
  }
  setNote(txKey: string, note: string) {
    return this.post('/web/tx/setNote', { txKey, note })
  }
  setMpcNote(txKey: string, note: string, id: string) {
    return this.post('/web/raw/setNote', { txKey, note, id })
  }
  searchRawTxRecords({ pageNumber = 1, pageSize = 50, queryParam = {} }) {
    return this.post<PageModel<TxRecordsModel>>('/web/raw/queryRawTxByPage', {
      pageNumber,
      pageSize,
      queryParam,
    })
  }
  getMpcDetail(id: string) {
    return this.post('/web/raw/queryRawTxDetail', id)
  }
  // web3记录
  getWeb3Records({ pageNumber = 1, pageSize = 50, queryParam = {} }) {
    return this.post<PageModel<TxRecordsModel>>('/signTx/queryTxByPage', {
      pageNumber,
      pageSize,
      queryParam,
    })
  }
  // web3分页条件
  getWeb3Condition() {
    return this.get<TxConditionModel>('/signTx/selectWeb3Condition')
  }
  getFundTxList(params: any) {
    return this.post('/tx/queryTokenFundTx', { ...params, pageSize: 20 })
  }
  cancelTx(txKey: string) {
    return this.post('/web/tx/cancelTx', { txKey })
  }
}
export default new TxRecordApi()
